"use client";
import React from "react";
import { useCommonContext } from "@/src/provider";
import { getDiscountText } from "@/src/utils";
import { useTranslation } from "@/src/i18n/client";
interface IProps {
    salePer: number;
}
const SalePerClient: React.FC<IProps> = (props) => {
    const { site } = useCommonContext();
    const { t } = useTranslation("common");

    return getDiscountText(site, props.salePer, t);
};
export default SalePerClient;
